import { Text } from 'app/design/primitives/text';
import { ListingType, type Listing } from 'app/types/listing';
import { FeatureType } from 'app/types/recommender';
import { Strategies } from '../../all-listings/components/recommended-listings';
import { DesktopRecommendationSection } from '../../all-listings/components/recommended-listings.large';
import { landingPageLargeStyles as styles } from '../large-styles';
import type { useDesktopLandingData } from '../use-desktop-landing-data';

export function MostPopularDiscoverySection({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { mostPopularRecommendations, shouldShowRecommendationSection } = data;
  if (!shouldShowRecommendationSection(mostPopularRecommendations)) return null;
  return (
    <DesktopRecommendationSection
      strategyProps={{
        strategy: Strategies.MostPopular,
        recommendationType: ListingType.offer,
        similarityType: FeatureType.CONTENT,
      }}
      recommendationState={mostPopularRecommendations}
      recommendations={mostPopularRecommendations.recommendations as Listing[] | undefined}
      titleSuffix={<Text style={styles.headerIcon}>🏆</Text>}
    />
  );
}
